import darkModeContext from "./contexts/DarkModeProvider";
import App from './App';
import { useContext } from "react";
import DarkModeProvider from "./contexts/DarkModeProvider";
import { AuthProvider } from "./contexts/AuthContext";




const Root = () => {


    return (
        <DarkModeProvider>
            <AuthProvider>
                <App />
            </AuthProvider>
        </DarkModeProvider>
    );
};

export default Root;